// @flow
import * as React from 'react';
import Card from './Card';
import { Fonts, Metrics } from '../../statsradio/themes';

const errorCardStyle = {
  ...Fonts.style.main,
  marginTop: Metrics.largeMargin,
  height: Fonts.style.main.fontSize * 2,
  minimumHeight: Fonts.style.main.fontSize * 2,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

type Props = {
  errorMessage: string;
}

const ErrorCard = ({ errorMessage }: Props) =>
  (<Card
    style={errorCardStyle}
  >
    {errorMessage}
  </Card>);

export default ErrorCard;



// WEBPACK FOOTER //
// ./src/common/components/ErrorCard.js